import { useCustom } from '@refinedev/core';
import { Card, Progress, Typography } from 'antd';
import { Pie } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { ProgressionStatsOut } from '@/api/generated/schemas';

export const ProgressionDistribution = () => {
  const { query } = useCustom<ProgressionStatsOut>({
    url: 'progress/progressions/stats',
    method: 'get',
  });

  const stats = query.data?.data;
  const completionPct = stats ? Math.round(stats.completion_rate * 100) : 0;

  const pieData = stats
    ? [
        { type: 'Nierozpoczęte', value: stats.not_started },
        { type: 'W trakcie', value: stats.in_progress },
        { type: 'Ukończone', value: stats.completed },
      ]
    : [];

  return (
    <Card title="Rozkład progresji" loading={query.isLoading}>
      {pieData.length > 0 ? (
        <>
          <Pie
            data={pieData}
            angleField="value"
            colorField="type"
            innerRadius={0.6}
            height={200}
            legend={BOTTOM_LEGEND}
          />
          <Progress
            percent={completionPct}
            size="small"
            style={{ marginTop: 8 }}
            format={(pct) => `${pct}% ukończono`}
          />
        </>
      ) : (
        <Typography.Text type="secondary">Brak danych</Typography.Text>
      )}
    </Card>
  );
};
